/**
 * Waitlist enhancements for the password page.
 * - Adds src:/med:/camp: customer tags from UTM parameters.
 * - Sends the Meta pixel Lead event once after a successful signup.
 * The form still submits without this script; it only adds tags and tracking.
 */
(() => {
  const STORAGE_KEY = 'gr-waitlist-utm';
  const LEAD_KEY = 'gr-waitlist-lead-sent';
  const UTM_TAGS = { utm_source: 'src', utm_medium: 'med', utm_campaign: 'camp' };

  const storage = {
    get(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch {
        return null;
      }
    },
    set(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch {
        /* Storage blocked; tags fall back to the current URL only. */
      }
    },
  };

  /** Tag values stay short and comma free so they read cleanly in Shopify Admin. */
  const cleanValue = (value) =>
    value
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9_\-.]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 40);

  const readUtmTags = () => {
    const params = new URLSearchParams(window.location.search);
    const tags = [];

    for (const [param, prefix] of Object.entries(UTM_TAGS)) {
      const value = params.get(param);
      if (value && cleanValue(value)) tags.push(`${prefix}:${cleanValue(value)}`);
    }

    if (tags.length) {
      storage.set(STORAGE_KEY, JSON.stringify(tags));
      return tags;
    }

    try {
      return JSON.parse(storage.get(STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  };

  const applyTags = (form, utmTags) => {
    const input = form.querySelector('[data-waitlist-tags]');
    if (!input || !utmTags.length) return;

    const base = input.value.split(',').map((tag) => tag.trim()).filter(Boolean);
    input.value = [...new Set([...base, ...utmTags])].join(',');
  };

  const sendLead = () => {
    if (storage.get(LEAD_KEY)) return;
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead');
      storage.set(LEAD_KEY, '1');
    }
  };

  const init = () => {
    const utmTags = readUtmTags();

    document.querySelectorAll('[data-waitlist-form]').forEach((form) => {
      applyTags(form, utmTags);
      form.addEventListener('submit', () => applyTags(form, readUtmTags()));
    });

    const success = document.querySelector('[data-waitlist-success]');
    if (success) {
      success.focus({ preventScroll: false });
      sendLead();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
